<template>
  <b-card class="shadow-sm">
    <!-- Cabeçalho -->
    <b-card-title class="mb-2 pl-6 pr-6 pt-6">
      <div>
        <b-icon icon="cash" variant="primary" class="mr-3" />
        <span>Ticket Médio / Venda</span>
      </div>

      <!-- Filtro de Período -->
      <FiltroPeriodo
        class="mt-4"
        :value="periodo"
        @apply="onApplyPeriodo"
        :auto-apply-on-mount="false"
      />
    </b-card-title>

    <!-- Corpo -->
    <b-card-body class="pl-6 pb-4">
      <!-- LOADING -->
      <div v-if="loading" class="display-4">
        <b-skeleton width="40%" height="36px" />
      </div>

      <!-- CONTEÚDO -->
      <div v-else>
        <h2 class="display-4 text-primary mb-0 font-weight-bold">
          {{ formatCurrency(ticketMedioNumber) }}
        </h2>
      </div>
    </b-card-body>
  </b-card>
</template>

<script>
import FiltroPeriodo from "./FiltroPeriodo.vue";

export default {
  name: "TicketMedio",
  components: { FiltroPeriodo },
  props: {
    ticketMedio: { type: [Number, String], default: 0 },
    loading: { type: Boolean, default: false },
    error: { type: String, default: null },

    // { inicio: 'YYYY-MM-DD', fim: 'YYYY-MM-DD' }
    periodo: {
      type: Object,
      default: () => ({ inicio: null, fim: null }),
    },

    // ignora o primeiro @apply disparado pelo FiltroPeriodo no mount
    ignoreInitialApply: { type: Boolean, default: true },
  },

  data() {
    return {
      // eslint-disable-next-line vue/no-reserved-keys
      _booting: true, // flag de boot para ignorar 1º apply automático
    };
  },

  mounted() {
    // depois do primeiro frame, consideramos que terminou o boot
    this.$nextTick(() => {
      this._booting = false;
    });
  },

  computed: {
    ticketMedioNumber() {
      const n = Number(this.ticketMedio);
      return Number.isFinite(n) ? n : 0;
    },
  },

  methods: {
    onApplyPeriodo({ inicio, fim }) {
      // 1) ignora apply automático do filtro no mount
      if (this._booting && this.ignoreInitialApply) return;

      // 2) evita emitir se vier incompleto
      if (!inicio || !fim) return;

      // 3) evita emitir se não houve mudança real
      const same =
        this.periodo &&
        this.periodo.inicio === inicio &&
        this.periodo.fim === fim;

      if (same) return;

      // 4) agora sim, emite pro pai buscar apenas o ticket médio
      this.$emit("change-periodo", { inicio, fim });
    },

    formatCurrency(v) {
      try {
        return new Intl.NumberFormat("pt-BR", {
          style: "currency",
          currency: "BRL",
          minimumFractionDigits: 2,
        }).format(v ?? 0);
      } catch {
        const num = Number(v ?? 0)
          .toFixed(2)
          .replace(".", ",");
        return `R$ ${num}`;
      }
    },

    formatRange(inicio, fim) {
      const fmt = (s) => {
        const [y, m, d] = (s || "").split("-").map(Number);
        return new Date(y || 0, (m || 1) - 1, d || 1).toLocaleDateString(
          "pt-BR"
        );
      };
      return `${fmt(inicio)} à ${fmt(fim)}`;
    },
  },
};
</script>


<style scoped>
/* opcional: mantém o card mais compacto e consistente com os outros */
.display-4 {
  line-height: 1.1;
}
</style>
